import React from 'react';

// "Install Kizabo" support (IMP-096). Chrome/Edge/Android fire beforeinstallprompt once the app is
// installable; it can fire before React renders, so it is caught here at startup.
let deferredPrompt = null;
const listeners = new Set();

function notify() {
    listeners.forEach(listener => listener(deferredPrompt !== null));
}

window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault(); // show our own menu item instead of the browser's mini-bar
    deferredPrompt = event;
    notify();
});

window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
});

// Returns [canInstall, install]
export function useInstallPrompt() {
    const [canInstall, setCanInstall] = React.useState(deferredPrompt !== null);

    React.useEffect(() => {
        listeners.add(setCanInstall);
        return () => listeners.delete(setCanInstall);
    }, []);

    async function install() {
        if (!deferredPrompt) return;
        const promptEvent = deferredPrompt;
        deferredPrompt = null; // a prompt can only be shown once
        notify();
        promptEvent.prompt();
        await promptEvent.userChoice;
    }

    return [canInstall, install];
}

export function registerServiceWorker() {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').catch(error => {
            console.error('Service worker registration failed:', error);
        });
    });
}
